import type { OptionalError } from "@somewear/model";
import * as Common from "@web/common/Common";
import type { IControlledInput } from "@web/common/ControlledInputController";
import Paths from "@web/common/Paths";
import * as React from "react";
import { Link } from "react-router-dom";

import * as LandingCommon from "./LandingCommon";

interface IProps extends OptionalError {
	emailInput: IControlledInput;
	resetPassword(): void;
}

const PasswordResetView: React.FunctionComponent<IProps> = (props: IProps) => (
	<div className="mx-2 w-full md:w-auto md:min-w-96">
		<form>
			<div>
				<LandingCommon.CenterHeader text="Reset password" />
				<LandingCommon.ErrorMessage error={props.error} />
				<LandingCommon.FirstInput error={props.error}>
					<LandingCommon.ControlledInputView
						type="email"
						id="email"
						placeholder="Email"
						required={true}
						value={props.emailInput.getValue()}
						controlledInput={props.emailInput}
					/>
				</LandingCommon.FirstInput>
				<Common.CenterContent>
					<LandingCommon.Button
						onClick={(evt) => {
							evt.preventDefault();
							props.resetPassword();
						}}
					>
						<Common.TitleButtonText>Send email</Common.TitleButtonText>
					</LandingCommon.Button>
				</Common.CenterContent>
				<Common.CenterContent>
					<Link to={Paths.Email}>
						<LandingCommon.LinkButton className="mt-2.5">Back</LandingCommon.LinkButton>
					</Link>
				</Common.CenterContent>
			</div>
		</form>
	</div>
);

export default PasswordResetView;
